import React, { useState, useEffect } from "react";
import { Button, Form, Input, message, Row, Col, Divider } from "antd";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { ArrowRightOutlined } from "@ant-design/icons";
import googleicon from "../Assets/Onboardingimages/googleicon.png";
import applelogo from "../Assets/Onboardingimages/applelogo.png";
import loadingbutton from "../Assets/Onboardingimages/Loading-button.png";
import Rectangular from "../Assets/Onboardingimages/Rectangular.png";
import cardimage from "../Assets/Onboardingimages/cardimage.png";
import card2image from "../Assets/Onboardingimages/card2image.png";
import card3image from "../Assets/Onboardingimages/card3image.png";
import Action from "../Assets/Onboardingimages/Action.png";
import Action2 from "../Assets/Onboardingimages/Action2.png";
import Action3 from "../Assets/Onboardingimages/Action3.png";
import actionarrow from "../Assets/Onboardingimages/action-arrow_right-outline.png";
// import { useInvite } from "../Users/InviteContext";
import { useAuth } from "../contexts/AuthContext";

import { URL } from "../helper/Mainurl";

import "../App.css";
import { HeaderSection } from "./HeaderSection";
import { FooterSection } from "./FooterSection";
const Login = () => {
  const [form] = Form.useForm();
  const { login } = useAuth();
  const [showPasswordInput, setShowPasswordInput] = useState(false);
  const [loginPage, setLoginPage] = useState(false);
  const [loginButton, setLoginButton] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  // const { setInviteDetails } = useInvite();

  const location = useLocation();
  const [inviteData, setInviteData] = useState({
    invite_email: "",
    invite_id: "",
  });
  const [isInviteLocked, setIsInviteLocked] = useState(false);
  // const [approveData, setApproveData] = useState({ approval: "", approval_email: "" });

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const invite_email =
      searchParams.get("invite_email") || localStorage.getItem("inviteEmail");
    const invite_id =
      searchParams.get("invite_id") || localStorage.getItem("inviteId");

    // const approval = searchParams.get("role_approval")
    // const approval_email = searchParams.get("approved_email")

    if (invite_email) {
      setInviteEmail(invite_email);
      setIsInviteLocked(true); // 🔒 disable field ONLY when value comes from invite
      form.setFieldsValue({ email: invite_email });
      setInviteData({ invite_email, invite_id });
    }
    // if (invite_email && invite_id) {
    //   setInviteData({ invite_email, invite_id });
    //   setInviteEmail(invite_email);
    //   // setInviteDetails(invite_email, invite_id);
    // }
    // else if (approval && approval_email){
    //   setApproveData({approval,approval_email})
    //   setInviteEmail(approval_email);  // ✅ Set inviteEmail here

    //   setTimeout(() => {
    //     form.setFieldsValue({ email: approval_email });
    //     form.validateFields(["email"]); // ✅ This forces validatijhgfvcdsxazsxdcfvgbhnjmk,okmijnuhbygvtfrcdexsedrcftvgybhunjimko,lokmijnuhbygvtfcrdexswzasexdrcftvgybhunjimkomijnuhbygvtfcrdxesxdrcftvgybhon to recognize the value
    //   }, 100);
    // }
  }, [location.search]);

  useEffect(() => {
    if (inviteData.invite_email) {
      form.setFieldsValue({ email: inviteData.invite_email });
    }
    // if (approveData.approval_email) {
    //   setInviteEmail(approveData.approval_email);

    //   // ✅ Set the form field properly and trigger validation
    //   form.setFieldsValue({ email: approveData.approval_email });
    //   form.validateFields(["email"]);
    // }
  }, [inviteData, form]);

  // console.log("Extracted Email:", inviteData.invite_email);
  // console.log("Extracted Invite ID:", inviteData.invite_id);
  if (inviteData.invite_id) {
    localStorage.setItem("inviteId", inviteData.invite_id); // Store invite ID in localStorage
  }

  const [inviteEmail, setInviteEmail] = useState(
    location.state?.invite_email
    //  || approveData.approval_email
  );

  const token = localStorage.getItem("authToken"); // Get token from localStorage

  const navigate = useNavigate();

  const handleContinue = () => {
    form
      .validateFields(["email"])
      .then(() => {
        setShowPasswordInput(true); // Show password input after email validation
      })
      .catch((error) => {
        console.error("Email validation failed:", error);
      });
  };

  const checkDevice = () => {
    let Name = "Unknown OS";
    if (navigator.userAgent.indexOf("Win") != -1) Name = "Windows OS";
    if (navigator.userAgent.indexOf("Mac") != -1) Name = "Macintosh";
    if (navigator.userAgent.indexOf("Linux") != -1) Name = "Linux OS";
    if (navigator.userAgent.indexOf("Android") != -1) Name = "Android OS";
    if (navigator.userAgent.indexOf("like Mac") != -1) Name = "iOS";
    return Name;
  };

  const handleLogin = async (values) => {
    const payload = {
      email: values.email,
      password: values.password,
    };
    let invite_id = localStorage.getItem("inviteId");
    if (invite_id) {
      payload.invite_id = invite_id;
    }

    try {
      const response = await fetch(`${URL}/v1/login`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      if (response.ok) {
        if (data.data && data.data?.token) {
          localStorage.removeItem("inviteId"); // Clear invite ID after successful login
          localStorage.setItem("authToken", data.data.token);
          login(data.data); // Update AuthContext with login data
          // console.log("Stored Token:", localStorage.getItem("authToken")); // Debugging
          const authData = data.data;
          message.success("Login successful!");
          let device = checkDevice();
          console.log(authData ,device, "device");

          // console.log('currentUser', currentUser)
          if (device == "Android OS" || device == "iOS") {
            let data = {
              username: authData.name,
              user_id: authData.user_id,
            };
            let obj = {
              eventName: "LOGIN",
              payload: JSON.stringify(data),
            };
            window.ReactNativeWebView?.postMessage(JSON.stringify(obj));
          }
          // Extract role_approval from URL params
          // const searchParams = new URLSearchParams(window.location.search);
          // const approval = searchParams.get("role_approval");

          // If approval exists, call the API; otherwise, navigate immediately
          // if (approval) {

          //   const payload = {
          //     approved_email:approveData.approval_email,
          //     role_approval:approveData.approval
          //   }
          //   try {
          //     const approvalResponse = await fetch(`${URL}/v1/member/approve-role`, {
          //       method: "POST",
          //       headers: {
          //         Accept: "application/json",
          //         Authorization: `Bearer ${data.data.token}`, // Use the received token
          //         "Content-Type": "application/json",
          //       },
          //       body: JSON.stringify(payload),
          //     });

          //     const approvalData = await approvalResponse.json();

          //     if (approvalResponse.ok) {
          //       console.log("Approval API Response:", approvalData);
          //     } else {
          //       console.error("Approval API failed:", approvalData);
          //       message.error(approvalData.message || "Approval failed.");
          //     }
          //   } catch (error) {
          //     console.error("Approval API request failed:", error);nhbgfvcdxszasxdcfvgbhnjmkmjinhubygvtfcrdxeszwawzsxdcfvgbhnjmkjnhbgvfcdxsza
          //   }
          // }

          // Navigate to dashboard (either after approval API or immediately if no approval)
          navigate("/dashboard");
        } else {
          message.error("Token not received. Login failed.");
        }
      } else {
        message.error(data.message || "Login failed!");
      }
    } catch (error) {
      console.error("Login request failed:", error);
    }
  };

  // useEffect(()=>{
  //   if(token){
  //     navigate('/dashboard')

  //   }

  // },[token])

  // const handleforgetPassword = (values) => {
  //   console.log("emaillogin::::::::::",values)

  //   navigate("/forgetpassword",{ state: { email: values.email } });
  // }

  const handleredirect = () => {
    navigate("/signupwithgoogle", { state: inviteData });
  };

  const handleLoginFormOpen = () => {
    setLoginPage(true);
  };

  const handleRedirectlogin = () => {
    setLoginPage(true);
  };

  const handlegoogleLogin = () => {
    // console.log("url:::::::::::", `${URL}/v1/auth/google/redirect`);
    try {
      window.location.href = `${URL}/v1/auth/google/redirect`;
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleOpen = () => {
    setLoginButton(true);

    setTimeout(() => {
      requestAnimationFrame(() => {
        // Ensures the next render cycle is complete
        const scrollTarget = document.getElementById("scroll");
        if (scrollTarget) {
          scrollTarget.scrollIntoView({
            behavior: "smooth",
            block: "end",
            inline: "nearest",
          });
        }
      });
    }, 100); // Delay a bit to ensure DOM updates
  };
  // const handleInput = (e) => {
  //   if (!location.state?.invite_email && !approveData.approval_email) {
  //     setInviteEmail(e.target.value);
  //     form.setFieldsValue({ email: e.target.value }); // Update Form state as well

  //   }
  // };
  return (
    <div style={{ height: "100%", overflow: "auto" }}>
      <HeaderSection />
      <div className="scrollable-content">
        {!loginPage ? (
          <div className="loginpage-description">
            <div className="loginpage-description-quelld-logo">
              <img src="/quelld-signup.png" />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "30px",
                marginBottom: "30px",
              }}
            >
              <img src={loadingbutton} width={32} />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "30px",
                marginBottom: "30px",
              }}
            >
              <Button
                width={182}
                onClick={handleLoginFormOpen}
                className="skip-btn"
              >
                {" "}
                Skip <img src={actionarrow} width={17} />
              </Button>
            </div>
            <div className="login-cards">
              <Row className="card-row" gutter={[24, 24]} justify="center">
                <Col className="gutter-row" xs={24} sm={12} md={6} lg={6}>
                  <div className="card-content">
                    <img src={cardimage} className="card-img" />
                    <div className="desc-heading">Welcome to Quelld</div>
                    <div className="desc-content">
                      Streamline your family's events, notifications, and
                      communications all in one place
                    </div>
                  </div>
                </Col>

                <Col className="gutter-row" xs={24} sm={12} md={6} lg={6}>
                  <div className="card-content">
                    <img src={card2image} className="card-img" />
                    <div className="desc-heading">Features You’ll Love</div>
                    <div className="desc-content">
                      Email Assistant: Turn school emails into calendar events{" "}
                      <br />
                      Co-Parenting Calendar: Coordinate with ease. <br />
                      Invite Capture: "Digitise physical invitations."
                    </div>
                  </div>
                </Col>

                <Col className="gutter-row" xs={24} sm={12} md={6} lg={6}>
                  <div className="card-content">
                    <img src={card3image} className="card-img" />
                    <div className="desc-heading">Why Quelld?</div>
                    <div className="desc-content">
                      Spend less time organising, more time enjoying life!
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "20px",
                marginBottom: "30px",
              }}
            >
              <Button onClick={handleRedirectlogin} className="get-started-btn">
                {" "}
                Get Started{" "}
                <ArrowRightOutlined width={17} style={{ fill: "#ffffff" }} />
              </Button>
            </div>
            {loginButton ? (
              <div id="scroll" style={{ marginTop: "60px" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    fontSize: "36px",
                    fontWeight: "500",
                  }}
                >
                  Where to Begin?
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    fontSize: "14px",
                    color: "#767A83",
                  }}
                >
                  Ready to start simplifying life?{" "}
                </div>

                <div className="started-btn-grp">
                  <Button
                    className="get-started-btn-next"
                    onClick={handleRedirectlogin}
                  >
                    Get started for free{" "}
                    <ArrowRightOutlined
                      width={17}
                      style={{ fill: "#ffffff" }}
                    />
                  </Button>
                  <Button
                    className="get-started-btn-next"
                    onClick={handleRedirectlogin}
                  >
                    {" "}
                    Explore paid plans{" "}
                    <ArrowRightOutlined
                      width={17}
                      style={{ fill: "#ffffff" }}
                    />
                  </Button>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          <div className="login-page">
            <div className="login-image">
              <img src="/quelld-signup.png" className="login-image" />
            </div>

            <div>
              {!showPasswordInput ? (
                <>
                  <div
                    style={{
                      fontSize: "28px",
                      justifyContent: "center",
                      display: "flex",
                      fontWeight: "500",
                      paddingTop: "20%",
                      paddingBottom: "8px",
                    }}
                  >
                    Hey there!
                  </div>
                  <div
                    style={{
                      fontSize: "16px",
                      justifyContent: "center",
                      display: "flex",
                      color: "#767A83",
                      textAlign: "center",
                    }}
                  >
                    Welcome to Quelld! We're excited to have you join us. Let's
                    Sign in and make your day awesome!{" "}
                  </div>
                </>
              ) : (
                <>
                  <div
                    style={{
                      fontSize: "28px",
                      justifyContent: "center",
                      display: "flex",
                      fontWeight: "500",
                      paddingTop: "20%",
                      paddingBottom: "8px",
                    }}
                  >
                    Welcome back!
                  </div>
                  <div
                    style={{
                      fontSize: "16px",
                      justifyContent: "center",
                      display: "flex",
                      color: "#767A83",
                      textAlign: "center",
                    }}
                  >
                    Sign in with your email and password to enjoy all the great
                    features on Quelld!{" "}
                  </div>
                </>
              )}
              <div className="login-form">
                <Form
                  form={form}
                  layout="vertical"
                  onFinish={handleLogin}
                  initialValues={{ email: inviteData.invite_email }}
                >
                  <Form.Item
                    name="email"
                    rules={[
                      { required: true, message: "Please enter your email!" },
                      {
                        pattern:
                          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                        message: "Please enter a valid email address!",
                      },
                    ]}
                  >
                    <div className="floating-label">
                      <Input
                        id="inviteEmail"
                        style={{ height: "40px" }}
                        placeholder=" "
                        value={inviteEmail}
                        disabled={isInviteLocked} // Disable if inviteEmail is pre-filled
                        onChange={(e) => {
                          setInviteEmail(e.target.value);
                          form.setFieldsValue({ email: e.target.value });
                        }}
                      />
                      <label htmlFor="inviteEmail">Email</label>
                    </div>
                  </Form.Item>
                  {!showPasswordInput ? (
                    <Button
                      type="primary"
                      onClick={handleContinue}
                      style={{ width: "100%", height: "52px" }}
                    >
                      Continue
                    </Button>
                  ) : (
                    <>
                      {/* Password Input (Visible after clicking Continue) */}
                      <Form.Item
                        name="password"
                        rules={[
                          {
                            required: true,
                            message: "Please enter your password!",
                          },
                          {
                            pattern:
                              /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/,
                            message:
                              "Password must have 8+ characters, 1 uppercase, 1 number, and 1 special character!",
                          },
                        ]}
                      >
                        <div className="floating-label">
                          <Input.Password placeholder=" " id="inPass" />
                          <label htmlFor="inPass">Password</label>
                        </div>
                      </Form.Item>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "end",
                          marginBottom: "30px",
                        }}
                      >
                        <Link
                          to="/forgetpassword"
                          state={{ email: form.getFieldValue("email") }}
                        >
                          <span
                            style={{
                              color: "#9A4FE0",
                              fontSize: "12px",
                              paddingTop: "15px",
                              paddingBottom: "15px",
                              cursor: "pointer",
                            }}
                          >
                            Forgot password?
                          </span>
                        </Link>
                      </div>
                      <Button
                        type="primary"
                        htmlType="submit"
                        style={{ width: "100%", height: "48px" }}
                      >
                        Login
                      </Button>
                    </>
                  )}
                  <div>
                    <Divider className="or-divider">
                      <div style={{ fontSize: "12px", color: "#767A83" }}>
                        Or Sign in with
                      </div>
                    </Divider>
                  </div>
                  <div>
                    <Button
                      className="social-button-google"
                      onClick={handlegoogleLogin}
                      style={{ width: "100%", height: "52px", color: "black" }}
                    >
                      <img src={googleicon} width={16} /> Google
                    </Button>
                    {/* <Button className='social-button-google' style={{width:'394px',height:'52px',color:'black'}}>
                  <img src={applelogo} width={16} /> Apple
                </Button> */}
                  </div>
                  <div>
                    <p className="signup-text">
                      No account yet?{" "}
                      <div
                        style={{
                          color: "#9A4FE0",
                          paddingLeft: "3px",
                          cursor: "pointer",
                        }}
                        onClick={handleredirect}
                      >
                        {" "}
                        Sign up now!
                      </div>
                    </p>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        )}
      </div>
      <FooterSection />
    </div>
  );
};

export default Login;
